<template>
  <div class="form" :class="{'form_transparent': transparent, 'form_inline': inline}">
    <label :for="inputId" class="label">
      {{ label }}
    </label>
    <input
      :class="{'is-danger': error, small, uppercase}"
      :id="inputId"
      class="input"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @keypress="$emit('keypress', $event)"
      @paste="$emit('paste', $event)"
      v-bind="$attrs"
    >
    <!-- TODO: show custom errors -->
    <span v-show="error" :class="{'error-text_top': errorTop}" class="error-text">Incorrect!</span>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    phonenumber: Boolean,
    value: [String, Number],
    inline: Boolean,
    inputId: String,
    error: Boolean,
    label: String,
    transparent: Boolean,
    errorTop: Boolean,
    small: Boolean,
    uppercase: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.form {
  position: relative;
}

.form {
  &_transparent {
    .input {
      background: transparent;
      padding: 0 0 19px;
      font-size: 13px;
      line-height: 16px;
    }
    .label {
      margin-bottom: 9px;
    }
  }
  &_inline {
    .input {
      width: 251px;
    }
    .error-text {
      right: auto;
      margin-top: 0;
      position: relative;
      display: inline-block;
      margin-left: 13px;
      vertical-align: middle;
    }
  }
}
.input {
  transition: border-color $transition/2;
  font-family: Montserrat;
  outline: none;
  padding: 0%;
  background: $grey-color6;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  color: $black-color1;
  padding: 16px 20px;
  width: 100%;
  border: 1px solid transparent;
  -moz-appearance: textfield;
  &::placeholder {
    color: $grey-color1;
  }
  &:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 30px $grey-color6 inset !important;
    border-color: $grey-color6 !important;
  }
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
}
.label {
  @include label;
}
.error-text {
  @include font(13px, $red-color3);
  font-weight: 500;
  display: block;
  text-align: right;
  position: absolute;
  right: 0;
  margin-top: 10px;
  &_top {
    top: -11px;
  }
}

.is-danger {
  border: 1px solid $red-color3;
}
.small {
  padding: 16px 19px;
}
.email-change__password,
.email-change__email {
  .label {
    margin-bottom: 8px;
  }
}
.target-value_orange-border {
  input {
    border-color: $orange-color2;
  }
}
  @media screen and (max-width: $phone-change-popup-mobile-bp) {
    .form_inline {
      .error-text {
        display: block;
        left: $side-margin;
        position: absolute;
        margin-left: 0;
        margin-top: 7px;
      }
    }
    .popup-input {
      .label {
        padding-left: $side-margin;
      }
      .input {
        padding-left: $side-margin;
        width: 100%;
      }
    }
  }
@media screen and (max-width: 439px) {
  .popup-input {
    .label {
      padding-left: $side-margin;
    }
    .input {
      padding-left: $side-margin;
    }
  }
}
@media screen and (max-width: 376px) {
  .target-value {
    .label {
      margin-left: $side-margin;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/uikit/InputEl.vue